import { useSelector } from 'react-redux';
import { getLoginStatus } from '@app/redux/customer/selectors';

const useUserIsLoggedIn = (): boolean => useSelector(getLoginStatus);

export default useUserIsLoggedIn;
